var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"protocolPolicyClass"},[_c('el-dialog',{attrs:{"visible":_vm.show,"align-center":""},on:{"update:visible":function($event){_vm.show=$event},"close":function($event){return _vm.$emit('update:value', false)}}},[_c('div',{staticClass:"iuacsoClass",domProps:{"innerHTML":_vm._s(_vm.concats)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }